import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetCreditHistory = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_HISTORY_REPLENISHMENT
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetCreditHistoryAction({
                    list: data.list,
                    page: data.countPage
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetCreditHistory as SetGetCreditHistory
}